import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FaEdit, FaTrash, FaSave } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from "react-redux";
import "./ManageUsers.css";
import { selectUserExists } from "../redux/userSlice";
import { useLocation } from "react-router-dom";
import { Base_Url } from "../config";
import axios from "axios";

const ManageDosUsers = () => {
  const [data, setData] = useState([]);
  const [editBool, setEditBool] = useState(false);
  const [isNewContact, setIsNewContact] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  const userDataRedux = useSelector((state) => state.user.userData);
  const userExists = useSelector(selectUserExists);
  const location = useLocation();

  const showToast = (message, type = 'info') => {
    // Instead of using toast directly, you can dispatch an action or use a custom event
    const event = new CustomEvent('show-toast', {
      detail: { message, type }
    });
    window.dispatchEvent(event);
  };

  const [editedData, setEditedData] = useState({
    id: null,
    name: "",
    userid: "",
    category: "",
    department: ""
  });

  useEffect(() => {
    fetchData();
    
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${Base_Url}/webmasters`);
      if (response.data) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch users", "error");
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (confirmDelete) {
      try {
        await axios.delete(`${Base_Url}/webmasters/${id}`);
        alert('Contact deleted successfully', 'success');
        await fetchData();
      } catch (error) {
        alert('Error deleting user', 'error');
      }
    }
  };

  const handleEdit = (id) => {
    const editedItem = data.find((item) => item.id === id);
    if (!editedItem) return;
    
    setEditedData({
      id: editedItem.id,
      name: editedItem.name,
      userid: editedItem.userid,
      category: editedItem.category,
      department: editedItem.department,
    });
    setEditBool(true);
  };

  const handleSave = async () => {
    try {
      if (!editedData.name?.trim() || !editedData.userid?.trim()) {
        alert('Name and User ID are required', 'error');
        return;
      }

      if (editedData.id) {
        const updatedData = { 
          ...editedData, 
          updated_by: userDataRedux?.userid,
          name: editedData.name.trim(),
          userid: editedData.userid.trim()
        };
        await axios.put(`${Base_Url}/webmasters/${editedData.id}`, updatedData);
        alert('Contact updated successfully', 'success');
      } else {
        const newData = { 
          ...editedData, 
          created_by: userDataRedux?.userid,
          name: editedData.name.trim(),
          userid: editedData.userid.trim()
        };
        await axios.post(`${Base_Url}/webmasters`, newData);
        alert('Contact added successfully', 'success');
      }
  
      setEditBool(false);
      setIsNewContact(false);
      await fetchData();
    } catch (error) {
    //   showToast('Error saving user', 'error');
      alert('Error saving user', 'error');
    }
  };

  const handleAdd = () => {
    setEditedData({
      id: null,
      name: "",
      userid: "",
      category: "",
      department: "",
    });
    setEditBool(true);
    setIsNewContact(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData(prev => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setEditBool(false);
    setIsNewContact(false);
    setEditedData({
      id: null,
      name: "",
      userid: "",
      category: "",
      department: ""
    });
  };

  // console.log(userExists)

  
  return (
    <div className="box-wrap">
      <div className="table-wrap-manage-users">
        <div className="h1 mb-4 mt-5 text-center text-dark">
          <span style={{ color: "#c21717" }}>MANAGE CSC</span>
          <span style={{ color: "#c21717" }}> @ </span>
          USERS
        </div>
        
        <table>
          <thead>
            <tr>
              <th className="thanti">Sr No.</th>
              <th className="thanti">Name</th>
              <th className="thanti">User Id</th>
              {userExists && <th className="thanti">Actions</th>}
            </tr>
          </thead>
          <tbody>
            {data
              ?.filter(elem => !elem.is_deleted)
              ?.map((elem, index) => (
                <tr key={elem.id || index}>
                  <td className="tdanti">{index + 1}</td>
                  <td className="tdantimanageusers" style={{textTransform: "none"}}>
                    {editBool && editedData.id === elem.id ? (
                      <input
                        type="text"
                        name="name"
                        value={editedData.name}
                        onChange={handleInputChange}
                        className="inputchnage"
                        style={{ border: "none" }}
                      />
                    ) : (
                      elem.name
                    )}
                  </td>
                  <td className="tdantimanageusers" style={{textTransform: "none"}}>
                    {editBool && editedData.id === elem.id ? (
                      <input
                        type="text"
                        name="userid"
                        value={editedData.userid}
                        onChange={handleInputChange}
                        className="inputchnage"
                        style={{ border: "none" }}
                      />
                    ) : (
                      elem.userid
                    )}
                  </td>
                  {userExists && (
                    <td className="tdanti action-icons">
                      {!editBool && (
                        <>
                          <FaEdit
                            className="action-icon me-2"
                            onClick={() => handleEdit(elem.id)}
                          />
                          <FaTrash
                            className="action-icon"
                            onClick={() => handleDelete(elem.id)}
                          />
                        </>
                      )}
                      {editBool && editedData.id === elem.id && (
                        <>
                          <FaSave
                            className="action-icon me-2 mt-1"
                            onClick={handleSave}
                          />
                          <AiOutlineClose
                            className="action-icon mt-1"
                            onClick={handleCancel}
                          />
                        </>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            {isNewContact && (
              <tr>
                <td className="tdanti">{data.length + 1}</td>
                <td className="tdantimanageusers">
                  <input
                    type="text"
                    name="name"
                    value={editedData.name}
                    onChange={handleInputChange}
                    className="inputchnage"
                    style={{ border: "none" }}
                  />
                </td>
                <td className="tdantimanageusers">
                  <input
                    type="text"
                    name="userid"
                    value={editedData.userid}
                    onChange={handleInputChange}
                    className="inputchnage"
                    style={{ border: "none" }}
                  />
                </td>
                {userExists && (
                  <td className="tdanti action-icons">
                    <FaSave
                      className="action-icon me-2 mt-1"
                      onClick={handleSave}
                    />
                    <AiOutlineClose
                      className="action-icon mt-1"
                      onClick={handleCancel}
                    />
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>

        {userExists && (
          <div className="d-flex justify-content-end align-items-center">
            <button className="add-contact-btn d-flex" onClick={handleAdd}>
              <span className="me-2" style={{ marginRight: "10px" }}>
                Add User
              </span>
              <FaCirclePlus className="mb-1" style={{ fontSize: "18px" }} />
            </button>
          </div>
        )}
      </div>
      
      {/* <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}
    </div>
  );
};

export default ManageDosUsers;